import Swal from "sweetalert2";

const Api = {
  data() {
    return {};
  },
  methods: {
    async Post(Servis, Data, Mesaj) {
      return this.ActionsPost({ Service: Servis, Data: Data }).then(
        (res) => {
          if (res.Succeeded == true) {
            if (Mesaj != false) {
              if (Mesaj === undefined || Mesaj === null) {
                this.$toast.success(this.$t("ToasMessage.PostPozitif"));
              } else {
                this.$toast.success(Mesaj);
              }
            }
            this.Get();
            return res;
          } else {
            let hata_mesaji="";
            //console.log(res)
                  if(res.Message!=null){
                    hata_mesaji=this.$t("ToasMessage.PostNegatif") +" \n"+res.Message;
                  } else {
                    hata_mesaji=this.$t("ToasMessage.PostNegatif");
                  }
             
              this.$toast.error(hata_mesaji);
           
            return res;
          }
        }
      );
    },
    async Update(Servis, Data, Mesaj) {
      return this.ActionsPut({ Service: Servis, Data: Data }).then((res) => {
        if (res.Succeeded == true) {
          if (Mesaj != false) {
            if (Mesaj === undefined || Mesaj === null) {
              this.$toast.success(this.$t("ToasMessage.UpdatePozitif"));
            } else {
              this.$toast.success(Mesaj);
            }
          }
          this.Get();
          return true;
        } else {
          //this.$toast.error(this.$t("ToasMessage.UpdateNegatif"));
    
          //console.log(res)

          let hata_mesaji=this.$t("ToasMessage.PostNegatif");
          if (res.errors.length>0){
            hata_mesaji="";
             for (var i=0; i<res.errors.length;i++){
                hata_mesaji=hata_mesaji+"\n"+res.errors[i];
             }
            
          }
          this.$toast.error(hata_mesaji);


          return false;
        }
      });
    },
    async AllUpdate(Servis, Data, Mesaj) {
      return this.ActionsAllPut({ Service: Servis, Data: Data }).then((res) => {
        if (res.Succeeded == true) {
          if (Mesaj != false) {
            if (Mesaj === undefined || Mesaj === null) {
              this.$toast.success(this.$t("ToasMessage.UpdatePozitif"));
            } else {
              this.$toast.success(res.Data);
            }
          }
          this.Get();
          return true;
        } else {
          //this.$toast.error(this.$t("ToasMessage.UpdateNegatif"));
          if(res.Message != null){
            this.$toast.error(res.Message);
          }
          return res;
         // return false;
        }
      });
    },
    async UpdateList(Servis, Data, Mesaj) {
      return this.ActionsPutList({ Service: Servis, Data: Data }).then(
        (res) => {
          if (res.Succeeded == true) {
            if (Mesaj != false) {
              if (Mesaj === undefined || Mesaj === null) {
                this.$toast.success(this.$t("ToasMessage.UpdatePozitif"));
              } else {
                this.$toast.success(Mesaj);
              }
            }
            this.Get();
            return true;
          } else {
            //this.$toast.error(this.$t("ToasMessage.UpdateNegatif"));
            this.$toast.error(res.Errors[0]);
            return false;
          }
        }
      );
    },
    async Delete(Servis, StrId, Mesaj) {
      return Swal.fire({
        title: this.$t("ToasMessage.DeletePopupBaslik"),
        text: this.$t("ToasMessage.DeletePopupContent"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: this.$t("ToasMessage.DeletePopupPozitif"),
        cancelButtonText: this.$t("ToasMessage.DeletePopupNegatif"),
      }).then((result) => {
        if (result.value) {
          return this.ActionsDelete({ Service: Servis, Id: StrId }).then((res) => {
            if (res.Succeeded == true) {
              this.Get();
              if (Mesaj != false) {
                if (Mesaj === undefined || Mesaj === null) {
                  this.$toast.success(this.$t("ToasMessage.DeletePozitif"));
                } else {
                  this.$toast.success(Mesaj);
                }
              }
              
              return true;
            } else {
              //this.$toast.error(this.$t("ToasMessage.DeleteNegatif"));
              this.$toast.error(res.Errors[0]);
            }
          });
        }
      });
    },
  },
};

export default Api;
